import { createPursuitTask } from "@/features/pursuit/api/apiPursuitTask";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

export function useCreatePursuitTask(pursuitId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPursuitTask,
    onSuccess: () => {
      queryClient.invalidateQueries(["pursuit-tasks", pursuitId]);
    },
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
  });
}
